import PropTypes from 'prop-types'
import React from 'react'
import { DetailPage } from '../src/modules/ads/detail/components'
import { CookiesHelper } from '../src/core/cookiesHelper/CookiesHelper'
import { AdsDetailApi } from '../src/modules/ads/detail/api'
import { setCurrentAd, setIsServer } from '../src/modules/ads/detail/actions'
import { fetchCitiesByCountry } from '../src/modules/geoObjects/cities/actions'
import { fetchPageMetaTags } from '../src/modules/common/actions'
import { connect } from 'react-redux'
import { Page404 } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.json'

class Ad extends React.Component {
  static async getInitialProps ({store, query, isServer, req}) {
    let userId, token

    if (req) {
      userId = req.cookies.userId || null
      token = req.cookies.token || null
    } else {
      const cookies = new CookiesHelper()
      userId = cookies.get('userId') || null
      token = cookies.get('token') || null
    }


    const api = new AdsDetailApi()

    let isPageExists = false

    const params = {
      seo: query.ad,
      locale: query?.locale?.toUpperCase() || 'ME'
    }

    if (userId && token) {
      params.userId = userId
      params.token = token
    }

    const { ad, error } = await api.getAd(params)

    const adProps = !error && ad ? ad : null
    store.dispatch(setCurrentAd(adProps))
    store.dispatch(setIsServer(isServer))

    if (adProps && adProps.category && adProps.category.id) {
      await store.dispatch(fetchPageMetaTags({ category: adProps.category.id }, query?.locale?.toUpperCase() || 'ME'))
      isPageExists = true
    }

    await store.dispatch(fetchCitiesByCountry(config.globalOptions.MontenegroId, query?.locale?.toUpperCase() || 'ME'))

    return {
      title: adProps
        ? getTitleForCategory(adProps)
        : isPageExists
          ? config.siteName : config.pages.notFoundTitle,
      isPageExists,
      state: Ad.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.ads.detail = currentState.ads.detail

      state.groups.elements = currentState.groups.elements

      state.geoObjects.cities = currentState.geoObjects.cities

      state.categories.elements = currentState.categories.elements
      state.categories.currentSubcategory = currentState.categories.currentSubcategory
      state.categories.specifications = currentState.categories.specifications
      state.categories.bySeo = currentState.categories.bySeo

      state.form = currentState.form
    }
    return state
  }

  render () {
    const {isPageExists} = this.props
    return isPageExists ? <DetailPage /> : <Page404 />
  }
}

const getTitleForCategory = (
  {category, titleCompiled, price, brand, product, service, serviceType, adsSpecifications, country, city, location}
) => {
  let title
  const titleParts = []
  const adTitle = titleCompiled
  if (adTitle) {
    titleParts.push(adTitle)
  }
  const priceTitle = price ? `Cijena ${price} €` : ''
  if (priceTitle) {
    titleParts.push(priceTitle)
  }
  let restPartOfTitle
  const arRestPartOfTitle = []
  if (country && country.name) {
    arRestPartOfTitle.push(country.name)
  }
  if (city && city.name) {
    arRestPartOfTitle.push(city.name)
  }
  if (location && location.name) {
    arRestPartOfTitle.push(location.name)
  }
  if (category && category.title) {
    arRestPartOfTitle.push(category.title)
  }
  restPartOfTitle = arRestPartOfTitle.join(' ')
  if (restPartOfTitle) {
    titleParts.push(restPartOfTitle)
  }
  title = titleParts.join(' - ')
  return title ? ` ${title} | ${config.siteName}` : config.siteName
}

Ad.propTypes = {
  isPageExists: PropTypes.bool.isRequired
}

Ad.defaultProps = {
  isPageExists: false
}

export default Ad
